<template>
  <div class="testv__message__item__wrapper">
    <div class="left__wrapper">
      <template v-if="type==='question'">
        <img class="avatar" src="https://cdn-static.sspai.com/page/testv/assets/avatar_placeholder.jpeg"/>
      </template>
      <template v-else-if="type==='answer'">
        <img class="avatar" src="https://cdn-static.sspai.com/page/testv/assets/avatar_testv.png"/>
      </template>
      <template v-else>
        <img class="avatar" :src="`${message.avatar}?imageMogr2/thumbnail/!160/crop/160x160`"/>
      </template>
    </div>
    <div class="right__wrapper">
      <div class="nickname">{{ type === 'question' ? '铁丝头子' : type === 'answer' ? 'TESTV' : message.name }}</div>
      <div :class="['message', message.type || '', { 'highlight': type === 'question' }]">
        <div ref="msgContent" v-html="message.message"></div>
        <SsButton2 v-if="message.type && ['postCard', 'videoCard'].includes(message.type)" class="btn" @click="open">
          <span>{{ message.type === 'videoCard' ? '去看看' : '前往试读' }}</span>
          <IconNext class="icon__next"/>
        </SsButton2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TestvMessageItem',

  props: {
    message: Object,
    type: String
  },

  methods: {
    open () {
      const a = this.$refs.msgContent.querySelector('a')
      const link = (a && a.href) || ''
      const target = (a && a.target) || '_blank'
      if (link) {
        this.$openLink(link, target)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/assets/styles/variable.styl"
.testv__message__item__wrapper {
  padding-left: var(--inset-TestIntroPhoneBox);
  padding-right: calc(48px * var(--scale-TestIntroPhoneBox));
  margin: var(--inset-TestIntroPhoneBox) 0;
  display: flex;
  column-gap: calc(8px * var(--scale-TestIntroPhoneBox));
  .left__wrapper {
    width: calc(40px * var(--scale-TestIntroPhoneBox));
    flex-shrink: 0;
    .avatar {
      width: 100%
      border-radius: 50%;
    }
  }
  .right__wrapper {
    .nickname {
      font-size: 13px;
      color: #6F7174;
      margin-bottom: 4px;
    }
    .message {
      background: #F7F7F9;
      border-radius: 8px 16px 16px 16px;
      font-size: 13px;
      color: #000;
      padding: 12px;
      &.postCard,
      &.videoCard,
      &.imgCard {
        border: 1px solid #E4E4E5;
        background: transparent;
        padding: 0;
        border-radius: 8px;
        position: relative;
        >>> a {
          display: block;
        }
        >>> img {
          width: 100%;
          border-radius: 8px;
        }
        .btn {
          position: absolute;
          font-size: 15px;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          bottom: 8px;
          right: 8px;
          column-gap: 4px;
          padding: 8px;
          border-radius: 4px;
          background: rgba(255, 255, 255, 0.20);
          backdrop-filter: blur(20px);
          .icon__next {
            width: 16px;
          }
        }
      }
      &.highlight {
        background: #FFECB0;
      }
    }
  }
}
</style>
